import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ApiService from '../../../../services/api';
import '../../css/editor.css';
import '../../css/teacher_list.css';
import DeleteIcon from '../../../../media/delete.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import User from '../../../../media/user.png';
import Save from '../../../../media/save.png';
import Delete from '../../../../media/delete.png';
import Trophy from '../../../../media/trophy.png';
import Certificate from '../../../../media/certificate2.png';
import unlock from '../../../../media/eye1.png';
import lock from '../../../../media/eye2.png';
import ActiveIcon from '../../../../media/active.png';
import InactiveIcon from '../../../../media/inactive.png';
import UserCourseProgressDetail from './user_detail';
import AdminSelect from './admin_select';
import Back from '../../../../media/back.png';

const EditUser = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const userName = location.state?.userName;
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [countries, setCountries] = useState([]);
  const [courses, setCourses] = useState([]);
  const [certificates, setCertificates] = useState([]);

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    password:'',
    confirmPassword: '',
    nation: '',
    city: '',
    tax_id: '',
  });

  const [errors, setErrors] = useState({});

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [selectedCourseSlug, setSelectedCourseSlug] = useState(null);
  const [courseDetail, setCourseDetail] = useState(null);
  const [loadingCourseDetail, setLoadingCourseDetail] = useState(false);
  const [openExamId, setOpenExamId] = useState(null);

  const ORG_DEFAULT_STATUS_OPTION = {
    value: null,
    label: "Tutte le organizzazioni"
  };

  const [selectedOrg, setSelectedOrg] = useState(ORG_DEFAULT_STATUS_OPTION);
  const [organizations, setOrganizations] = useState([]);

  const DEFAULT_STATUS_OPTION = {
    value: null,
    label: "Filtra per iscrizione"
  };


  const [selectedStatus, setSelectedStatus] = useState(DEFAULT_STATUS_OPTION);

  const statusOptions = [
    DEFAULT_STATUS_OPTION,
    {
      value: "active",
      label: "Iscrizione attiva"
    },
    {
      value: "inactive",
      label: "Iscrizione non attiva"
    }
  ];

  

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await ApiService.getUser(slug);
        setForm({
          first_name: data.first_name || '',
          last_name: data.last_name || '',
          username: data.username,
          email: data.email || '',
          nation: data.nation || '',
          city: data.city || '',
          tax_id: data.tax_id || '',
          password: '',
          confirmPassword: '',
        });
      } catch (err) {
        toast.error('Errore nel caricamento utente');
        navigate('/admin/utenti');
      }
    };

    if (slug) fetchUser();
  }, [slug, navigate]);

  useEffect(() => {
        const fetchCountries = async () => {
          try {
            const res = await ApiService.getCountries();
            setCountries(res);
          } catch (err) {
            console.error('Errore:', err);
          } finally {
            setLoading(false);
          }
        };
    
        fetchCountries();
      }, []);

  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  
  const validate = () => {
    const errs = {};

    if (!form.first_name.trim()) errs.first_name = ['Inserisci nome', true];
    if (!form.last_name.trim()) errs.last_name = ['Inserisci cognome', true];
    if (!form.username.trim()) errs.username = ['Inserisci username', true];
    if (!form.email.trim()) errs.email = ['Inserisci indirizzo email', true];
    if (!form.nation.trim()) errs.nation = ['Non hai effettuato nessuna scelta', true];
    if (!form.city.trim()) errs.city =  ['Inserisci una località', true];
    if (!form.tax_id.trim()) errs.tax_id = ['Inserisci il codice fiscale', true];

    return errs;
  };

  const getError = (field) => {
      if (!errors[field]) return null;

      return Array.isArray(errors[field])
        ? errors[field][0]
        : errors[field];
    };

  

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);

      const { password, confirmPassword, ...rest } = form;

      const payload = {
        ...rest,
        ...(password || confirmPassword
          ? {
              password,
              confirmPassword
            }
          : {})
      };


      console.log("PAYLOAD UPDATE:", payload);

      await ApiService.updateUser(slug, payload);

      toast.success('Utente aggiornato con successo!');
      navigate('/admin/utenti');

    } catch (err) {
        console.error(err);

        if (err.response?.data) {
          setErrors(err.response.data);
        } else {
          toast.error("Errore durante l'aggiornamento dei dati");
        }
      } finally {
      setSaving(false);
    }
  };

  
  const handleDelete = async () => {
    confirmToast({
            message: `Sei sicuro di voler eliminare questo utente?`,
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                setDeleting(true);
                await ApiService.deleteUser(slug);
                toast.success(`Utente eliminato con successo`);
                navigate('/admin/utenti');
              } catch (err) {
                toast.error("Errore durante l'eliminazione");       
              }
              setDeleting(false);
            },
          });
  };

  useEffect(() => {
    const loadOrgs = async () => {
      try {
        const res = await ApiService.getOrganizations();

        const formatted = [
          {
            value: null,
            label: "Tutte le organizzazioni"
          },
          ...res.map(org => ({
            value: org.slug || org.id,
            label: org.name
          }))
        ];

        setOrganizations(formatted);
      } catch (err) {
        console.error(err);
      }
    };

    loadOrgs();
  }, []);

  

  useEffect(() => {
    const loadCourses = async () => {
      try {
        const data = await ApiService.getMyCourseAdmin(
          slug,
          selectedOrg?.value || null
        );
        setCourses(data);
      } catch (err) {
        console.error(err);
      }
    };

    if (slug) loadCourses();
  }, [slug, selectedOrg]);

useEffect(() => {
  const loadCertificates = async () => {
    try {
      const res = await ApiService.getAdminCertificate(
        slug,
        selectedOrg?.value || null
      );

      const certs = (res || []).map((c) => ({
        id: c.id,
        title: c.course_title,
        file: c.file,
      }));

      setCertificates(certs);
    } catch (err) {
      console.error(err);
      setCertificates([]);
    }
  };

  if (slug) loadCertificates();
}, [slug, selectedOrg]);

  const filteredCourses = courses.filter(course => {
    if (!selectedStatus.value) return true;

    if (selectedStatus.value === "active") {
      return course.is_active;
    }

    if (selectedStatus.value === "inactive") {
      return !course.is_active;
    }

    return true;
  });


  const handleCourseClick = async (courseSlug) => {
    setSelectedCourseSlug(courseSlug);
    setLoadingCourseDetail(true);

    try {
      const data = await ApiService.getUserCourseProgressDetail(slug, courseSlug);
      setCourseDetail(data);
    } catch (err) {
      toast.error("Errore caricamento dettaglio corso");
    } finally {
      setLoadingCourseDetail(false);
    }
  };

   if (loading) {
      return ;
    }


  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      
        <h2><img src={User} alt="crea utente" className="section-image" /> Modifica utente</h2>

        <button
          type="button"
          onClick={handleDelete}
          disabled={saving || deleting}
          style={{ backgroundColor: 'crimson' }}
        >
          <img src={Delete} className="button-image2" />
          {deleting ? "Eliminazione..." : "Elimina"}
        </button>

      </div>

      <div className='account-container2'>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/utenti`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco degli utenti
      </button>

      <div  className="form-grid">

        <div className="form-group">
        <label>Nome *</label>
        <input
          type="text"
          name="first_name"
          value={form.first_name}
          onChange={handleChange}
          className={`input ${errors.first_name ? "error" : ""}`}
          maxLength={250}
        />
        {getError('first_name') && (
          <span className="error">
            {getError('first_name')}
          </span>
        )}
       

        </div>

        <div className="form-group">
        <label>Cognome *</label>
        <input
          type="text"
          name="last_name"
          value={form.last_name}
          onChange={handleChange}
          className={`input ${errors.last_name ? "error" : ""}`}
          maxLength={250}
        />
        {getError('last_name') && (
          <span className="error">
            {getError('last_name')}
          </span>
        )}
        
        </div>
        
        <div className="form-group">
        <label>Username *</label>
        <input
          type="text"
          name="username"
          value={form.username}
          onChange={handleChange}
          className={`input ${errors.username ? "error" : ""}`}
          maxLength={150}
        />
        {getError('username') && (
          <span className="error">
            {getError('username')}
          </span>
        )}
       
        </div>

        <div className="form-group">
        <label>Indirizzo email *</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          className={`input ${errors.email ? "error" : ""}`}
          maxLength={250}
        />
         {getError('email') && (
            <span className="error">
              {getError('email')}
            </span>
          )}
        
        </div>
        
        <div className="form-group">
          <label>Cambia Password</label>

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={form.password}
              onChange={handleChange}
              className={`password-input2 ${errors.password ? "error" : ""}`}
              maxLength={128}
            />

            <button
              type="button"
              onClick={() => setShowPassword(prev => !prev)}
              className="toggle-password-btn"
              style={{background: 'transparent', boxShadow:'none', transform:'none', marginTop:'-20px'}}
            >
              <img
                src={showPassword ? lock : unlock}
                alt="toggle password"
                className="eye-icon"
              />
            </button>
          </div>
          {getError('password') && (<span className="error">{getError('password')}</span>)}
        </div>

          <div className="form-group">
            <label>Conferma Password *</label>

            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                className={`password-input2 ${errors.confirmPassword ? "error" : ""}`}
                maxLength={128}
              />

              <button
                type="button"
                onClick={() => setShowConfirmPassword(prev => !prev)}
                className="toggle-password-btn"
                style={{background: 'transparent', boxShadow:'none', transform:'none', marginTop:'-20px'}}
              >
                <img
                  src={showConfirmPassword ? lock : unlock}
                  alt="toggle confirm password"
                  className="eye-icon"
                />
              </button>
            </div>
            {getError('confirmPassword') && (
              <span className="error">
                {getError('confirmPassword')}
              </span>
            )}
          </div>
        
        <div className="form-group">
        <label>Nazione *</label>
        <AdminSelect
          options={countries}
          value={countries.find(c => c.value === form.nation) || null}
          onChange={(selected) =>
            setForm(prev => ({
              ...prev,
              nation: selected?.value || ''
            }))
          }
          placeholder="Seleziona una nazione"
        />
          {getError('nation') && (
            <span className="error">
              {getError('nation')}
            </span>
          )}
       
        </div>

        <div className="form-group">
        <label>Città / Località *</label>
        <input
          type="text"
          name="city"
          value={form.city}
          onChange={handleChange}
          className={`input ${errors.city ? "error" : ""}`}
          maxLength={250}
        />
         {getError('city') && (
            <span className="error">
              {getError('city')}
            </span>
          )}
        
        </div>

        <div className="form-group">
        <label>Codice Fiscale *</label>
        <input
          type="text"
          name="tax_id"
          value={form.tax_id}
          onChange={handleChange}
          className={`input ${errors.tax_id ? "error" : ""}`}
          maxLength={16}
        />
        {getError('tax_id') && (
          <span className="error">
            {getError('tax_id')}
          </span>
        )}

        </div>
        
        
      </div>
      </div>

      <div style={{maxWidth: '100%'}}> 
          <div style={{display: 'flex', flexDirection: 'column', gap: '30px'}}>
            <AdminSelect
              options={organizations}
              value={selectedOrg}
              onChange={(selected) => {
                setSelectedOrg(selected);
              }}
              placeholder="Tutte le organizzazioni"
            />


            <AdminSelect
              options={statusOptions}
              value={selectedStatus}
              onChange={setSelectedStatus}
              placeholder="Filtra per iscrizione"
            />
          </div>
        
        
        <div style={{marginTop:"40px"}}>
          <h2>Corsi</h2>
          {filteredCourses === 0 && (
            <p>Nessun corso disponibile</p>
          )}

          {!selectedCourseSlug && (
            <div>
              {filteredCourses.map(c => (
                <div
                  key={c.id}
                  onClick={() => handleCourseClick(c.slug)}
                  className="course-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    cursor: "pointer"
                  }}
                >
                  <div className="course-item-left">
                    <img
                      src={c.main_img}
                      alt={c.title}
                      style={{
                        width: 60,
                        height: 60,
                        marginRight: 10,
                        objectFit: "cover",
                        borderRadius: "36px"
                      }}
                    />
                    <span title={`${c.title}`}>{c.title}</span>
                  </div>

                  <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img src={Trophy} alt="" className="profile-progress" />
                    {c.total_progress} %

                    <img
                      src={c.is_active ? ActiveIcon : InactiveIcon}
                      alt={c.is_active ? "Attivo" : "Disattivo"}
                      style={{
                        width: 20,
                        height: 20,
                        marginLeft: 6
                      }}
                    />
                  </span>
                </div>
              ))}
            </div>
          )}

          {selectedCourseSlug && courseDetail && (
            <UserCourseProgressDetail
              data={courseDetail}
              openExamId={openExamId}
              setOpenExamId={setOpenExamId}
              onBack={() => {
                setSelectedCourseSlug(null);
                setCourseDetail(null);
                setOpenExamId(null);
              }}
            />
          )}
        </div>

         <div style={{marginTop:"40px"}}>
            <h2>Certificati</h2>

            {certificates.length === 0 && (
              <p>Nessun certificato disponibile</p>
            )}

            {certificates.map(cert => (
              <div
                key={cert.id}
                className="course-item"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  cursor: "pointer",
                  padding: "20px"
                }}
                onClick={() => window.open(cert.file, "_blank")}
              >
                <div className="course-item-left">
                  <img
                    src={Certificate}
                    alt=""
                    style={{ width: 30, height: 30, marginRight: 10 }}
                  />
                  <span title={`Visualizza certificato del corso ${cert.title}`}>Visualizza certificato del corso {cert.title}</span>
                </div>
              </div>
            ))}
          </div>
      </div>


      <button type="submit" disabled={saving || deleting} style={{ backgroundColor: '#2ecc71', marginTop: "50px" }}>
        <img src={Save} alt="Salva" className="button-image2" />
        {saving ? 'Salvataggio in corso...' : 'Salva'}
      </button>
    </form>
  );
};

export default EditUser;